import { LoadState } from "../../constants/enums";
import { ICompanyOutlet, ICompanyOutletState } from "./companyOutlet.types";

export const initialCompanyOutlet: ICompanyOutlet = {
	company_outlet_uuid: "",
	company_outlet_name: "",
	remark: null,
	logo: null,
	status: "ACTIVE",
	create_ts: "",
	insert_ts: "",
	created_by_uuid: "",
};

export const initialCompanyOutletState: ICompanyOutletState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	companyOutlet: {
		data: initialCompanyOutlet,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
